<app-root-styler></app-root-styler>
<a routerLink="/" class="logo" tabindex="-1">
    <img class="logo-icon" src="/assets/app-logo.svg" alt="ABBYY® FlexiCapture Cloud" />
</a>
